// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"cd59dfbc","767":"22676177","885":"9571f587"}[chunkId] + ".chunk.js";
};